import { Box, Typography, useMediaQuery } from "@mui/material";

const VehicleDriverDetails = ({ tripDetailsData }: { tripDetailsData: any }) => {
  console.log('trip', tripDetailsData);
  const isMobile = useMediaQuery("(max-width: 640px)");
  
  const vehicleData = {
    vehicleId: tripDetailsData?.vehicleDetails?.vehicleRegistrationNo || "NA",
    vehicleName: "NA",
    fuelRequired: "NA",
    fuelConsumed: "NA",
  };

  const driverData = {
    employeeId: tripDetailsData?.tripDetails?.driverId,
    driverName: tripDetailsData?.tripDetails?.driverName,
    driverContact: "NA",
  };

  return (
    <Box className="p-8 bg-white shadow-md rounded-lg">
      {/* Vehicle Details */}
      <Typography className="text-xl font-bold mb-6">Vehicle Details</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Vehicle ID</Typography>
            <Typography className="text-gray-600">{vehicleData.vehicleId}</Typography>
          </div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Fuel Required for Trip</Typography>
            <Typography className="text-gray-600">{vehicleData.fuelRequired}</Typography>
          </div>
        </div>

        <div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Vehicle Name</Typography>
            <Typography className="text-gray-600">{vehicleData.vehicleName}</Typography>
          </div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Fuel Consumed</Typography>
            <Typography className="text-gray-600">{vehicleData.fuelConsumed}</Typography>
          </div>
        </div>
      </div>

      {/* Driver Details */}
      <Typography className="text-xl font-bold mt-10 mb-6">Driver Details</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Employee ID</Typography>
            <Typography className="text-gray-600">{driverData.employeeId}</Typography>
          </div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Driver's Contact</Typography>
            <Typography className="text-gray-600">{driverData.driverContact}</Typography>
          </div>
        </div>

        <div>
          <div className="mb-4">
            <Typography className="text-sm font-medium text-gray-700">Driver Name</Typography>
            <Typography className="text-blue-600 underline">{driverData.driverName}</Typography>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default VehicleDriverDetails;
